









































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseDeliveryItemView extends Vue {
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.PurchaseDeliveryItem[] = new Array(0);
  public params: Common.DeliveryItemQuery = new Common.DeliveryItemQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.DeliveryItemImportQuery('入荷明細',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.DeliveryItemExportQuery('入荷明細',this.params,Common.SalesPurchaseFlags.Purchase);
  public hasLicenseCurrency: boolean = false;
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryItemNo', text: '明細番号' },
    { value: 'bookDate', text: '仕入日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'commodity', text: '商品' },
    { value: 'warehouse', text: '入庫倉庫' },
// <!--    { value: 'receiver', text: '納入先' },
    { value: 'deliveryNo', text: '入荷番号' },
    { value: 'deliveryDate', text: '入荷日' },
    { value: 'orderItemNo', text: '発注明細番号' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'orderRefNo', text: '発注管理番号' },
    { value: 'deliveryRefNo', text: '入荷管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;    
  public DeliveryFlags = Common.DeliveryFlags;
  public visibleTypes = Common.visibleTypes;

  @Prop() public deliveryNo:string;
  @Prop() public deliveryItemNo:string;
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.StockBalanceJournalStatus;      
  @Prop() public deliveryDateTo: Date;  
  @Prop() public deliveryDateFrom: Date;  
  @Prop({default:null}) public popup: Components.PopupEditor; 
  @Prop() public segment:Common.Segment;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],24,'grid');


  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ

    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      // new Common.GridItemConfiguration('明細ID', 150),
      // new Common.GridItemConfiguration('行番号', 150),
      new Common.GridItemConfiguration('明細番号', 150),     
      new Common.GridItemConfiguration('仕入日', 150),       
      new Common.GridItemConfiguration('仕入先', 150),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('単位', 150),
      new Common.GridItemConfiguration('入荷数量', 150),
      new Common.GridItemConfiguration('納入区分', 150),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      // new Common.GridItemConfiguration('納入先', 150),
      new Common.GridItemConfiguration('入荷番号', 150),
      // new Common.GridItemConfiguration('入荷予定日', 150),
      new Common.GridItemConfiguration('入荷日', 150),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('単価', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('発注明細番号', 150),
      new Common.GridItemConfiguration('案件', 150),
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('調整数量', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税抜金額', 150),
      new Common.GridItemConfiguration('計上金額', 150,this.hasLicenseCurrency),
      // new Common.GridItemConfiguration('備考', 150),
      new Common.GridItemConfiguration('発注管理番号', 150),
      new Common.GridItemConfiguration('入荷管理番号', 150),
      // new Common.GridItemConfiguration('受注管理番号', 150),
      // new Common.GridItemConfiguration('顧客注文番号', 150),
      // new Common.GridItemConfiguration('倉庫', 150),
      // new Common.GridItemConfiguration('ワークフロー', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,true,true));
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.deliveryNo) {
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }
    else if(this.deliveryItemNo) {
      this.params.deliveryItemNo = this.deliveryItemNo;
      this.params.state = null;
    }
    else if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.orderItemNo) {
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.deliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
    if (this.segment) this.params.segment = this.segment;
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;   
    if (this.deliveryDateTo)this.params.deliveryDateTo = this.deliveryDateTo;        
    if (this.deliveryDateFrom)this.params.deliveryDateFrom = this.deliveryDateFrom;     

    this.params.isInvoiceItem = true;//delivery.counterpartをロードするため
  }
  //Vue初期化する前にCommodityロード処理を実施～Component.Hookはmain.tsに記載
  public beforeRouteEnter (to:any, from:any, next :Function) {
    //commodityCodeからcommodityをロード
    if (to.query.commodityCode){
      //thisが使えないためVue.prototypeからapiを取得
      var api = Vue.prototype.$api as Common.Api;
      api.execute(new Common.CommodityCodeQuery(to.query.commodityCode as string)).then(res =>{
        //vueインスタンスのparameterに直接セット
        next((vm:any) => vm.params.commodity = (res as Common.Commodity));      
      });
    } else {
      next();
    }
    
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
    this.$api.formatter.ensureListLoaded('workflow_charge');
  }
  public async onCreate(obj: Common.PurchaseDeliveryItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_purchaseDeliveryItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 一覧でチェックされている出荷明細
  public checkedDeliveryItems: Array<Common.DeliveryItem>= new Array(0);
  public getCheckedDeliveryItems(){
    this.checkedDeliveryItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedDeliveryItems.push(obj);
      }
    });
  }

  // 返品ダイアログ用プロパティ
  public rdCaptions = new Array();
  public rdWidths = new Array();
  public rdSlots = new Array();
  public rdGridConfig:Common.GridConfiguration = null;

  public rdPic: string = '';
  public rdReturnDate: Date = new Date().getCalendarDate();
  public rdWorkflowId = 0;
  public rdInvoiceWorkflowId = 0;
  // ワークフロー処理用プロパティ
  public rdButtonNames: Array<string> = null;
  public rdButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showReturnDeliveryDialog() {
    this.getCheckedDeliveryItems();

    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedDeliveryItems: this.checkedDeliveryItems,
          salesPurchaseFlag: Common.SalesPurchaseFlags.Purchase,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  //   // ダイアログ表示前バリデーション
  //   if(this.checkedDeliveryItems.length == 0){
  //     this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
  //     this.$api.modal.show('', '返品の入荷明細が選択されています。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
  //     this.$api.modal.show('', '部門の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
  //     this.$api.modal.show('', '仕入先の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }
  //   if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
  //     this.$api.modal.show('', '倉庫の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
  //     return;
  //   }

  //   // 明細の予備項目表示の可変対応

  //   this.rdGridConfig = new Common.GridConfiguration([],0,'col');
  //   this.rdGridConfig.setGridItems(
  //     new Common.GridItemConfiguration('商品', 150),
  //     new Common.GridItemConfiguration('SKU', 150),
  //     new Common.GridItemConfiguration('返品数量', 150),
  //     new Common.GridItemConfiguration('調整数量', 150),
  //   );
  //   this.rdGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));
  //   this.rdCaptions =this.rdGridConfig.gridCaptions;
  //   this.rdWidths = this.rdGridConfig.gridWidths;
  //   this.rdSlots = this.rdGridConfig.gridSlots;

  //   // プロパティの初期化
  //   this.rdPic = this.$api.auth.userId;
  //   this.rdReturnDate = new Date().getCalendarDate();
  //   this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseDelivery');
  //   this.rdInvoiceWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseInvoice');
  //   this.onReturnDeliveryChangeWorkflow();

  //   // ダイアログの表示
  //   var items = this.checkedDeliveryItems.map(item => item.copy());
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
  //   (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public onReturnDeliveryChangeWorkflow(){
    this.rdButtonNames=new Array();
    this.rdButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.rdButtonNames.push("入荷保存");
    if(this.rdWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseDelivery', this.rdWorkflowId, Common.DeliveryStatus.PurchaseDeliverySaving);
      actions.forEach(action => {
        this.rdButtonNames.push(action.actionName);
        this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }
  // // 返品処理の実行
  // public async submitReturnDelivery(list: Array<Common.DeliveryItem>, index:number) {
  //  // クエリの設定
  //   var query = new Common.ReturnDeliveryQuery();
  //   query.pic = this.rdPic;
  //   query.deliveryDate = this.rdReturnDate;
  //   query.deliveryItems = new Array();
  //   query.baseItems = this.checkedDeliveryItems;
  //   query.workflowId = this.rdWorkflowId;
  //   query.invoiceWorkflowId = this.rdInvoiceWorkflowId;    
  //   query.actionId = this.rdButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
  //   list.forEach(item =>{
  //     var returnItem = item.copy();
  //     returnItem.quantity *= -1;
  //     returnItem.adjustmentQuantity *= -1;
  //     query.deliveryItems.push(returnItem);
  //   });

  //   // 返品処理の実行
  //   // this.$api.execute(query)
  //   // .finally(()=>{
  //   //   this.refreshListView();
  //   // });

  //   return this.$api.execute(query,true).then(res => {
  //     //何も更新されないが..
  //      (this.$refs.mainList as Components.ListView).reload();
  //     var returnDelivery = res as Common.Delivery;
  //     this.$api.modal.show('処理結果','以下の入荷伝票が作成されました。',true,null,[new Common.ModalLink(returnDelivery.deliveryNo, String.format('/purchase/PurchaseDelivery?deliveryNo={0}',returnDelivery.deliveryNo))]);
  //     return true;
  //   }).catch(()=>{return false;});        
  // }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.DeliveryItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseDeliveryItem){
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(item.delivery, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 状態から編集可能か判別する
  public isEditable(item:Common.PurchaseDeliveryItem, shouldCheckOrderItem:boolean, shouldCheckDelivering:boolean, shouldCheckTransitPost:boolean):boolean{
    if(shouldCheckTransitPost && item.delivery.isTransitPost) return false;  // 未着品計上の場合編集不可
    if(shouldCheckOrderItem && item.orderItem != null) return false;  // 紐づく発注明細がある場合編集不可
    if(item.state == Common.StockBalanceJournalStatus.PurchaseDeliverySaving) return true;
    if(shouldCheckDelivering && item.state == Common.StockBalanceJournalStatus.PurchaseDelivering) return true;
    return false;
  }
  
  // 単価・単価取得が編集可能か判別する
  public isPriceEditable(item:Common.PurchaseDeliveryItem):boolean{
    if(item.orderItem != null && (this.$api.tenantSettings as Common.TenantSettings).purchaseDeliveryPriceChangeFlag == false) return false;  // 紐づく発注明細があり、単価変更が許可されていない場合編集不可
    if(item.isPurchaseInvoicePost==false) return true;
    return false;
  }

  // 発注明細一覧へ遷移する
  public showPurchaseOrderItem(itemNo: string){
    if(itemNo) this.$router.push(String.format('/purchase/PurchaseOrderItem?orderItemNo={0}',itemNo));
  }

  // 入荷一覧へ遷移する
  public showPurchaseDelivery() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseDeliveryItem;
    if(obj.delivery) this.$router.push(String.format('/purchase/PurchaseDelivery?deliveryNo={0}', obj.delivery.deliveryNo));
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseDeliveryItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseDelivery, sourceNo : item.deliveryNo, isItem: true},this.$el);
  }
  // 出荷明細一覧への遷移ボタンの非活性制御
  public disabledShowSalesDeliveryItemButton(item: Common.DeliveryItem):boolean{
    if(item.state == Common.StockBalanceJournalStatus.PurchaseDeliverySaving) return true;
    return item.deliveryFlag == Common.DeliveryFlags.Stock;
  }

  // 出荷明細一覧へ遷移する
  public showSalesDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseDeliveryItem;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?purchaseDeliveryItemNo={0}', obj.deliveryItemNo));
      window.open(routeData.href, '_blank');
    }
  }


  //諸掛按分処理
  //諸掛按分処理用プロパティ
  public caConfig:Common.GridConfiguration = new Common.GridConfiguration([],0,'col');
  public caPic: string = '';
  public caBookDate: Date = new Date().getCalendarDate();
  public caCurrencyCode: string='';
  public caProportionalDivision: Common.ProportionalDivisionFlags = Common.ProportionalDivisionFlags.ByQuantity;
  public caExchangeRate:number = 0;
  public caRefNo : string = '';
  public caWorkflowId: number = 0;
  public caItems : Common.PurchaseCharge[] = [];
  public caDecimal : number = 0;
  // ワークフロー処理用プロパティ
  public caButtonNames: Array<string> = null;
  public caButtonIndexIdArray: Array<{index:number,actionId:number}> =null;

  // 返品処理ダイアログを表示
  public showChargeAllocationDialog() {
    this.getCheckedDeliveryItems();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.state != Common.StockBalanceJournalStatus.PurchaseDeliveryCompleted).length > 0){
      this.$api.modal.show('', '未処理・入荷待ちの明細は選択できません。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる入荷明細を、同じ諸掛伝票にまとめることはできません。', true, null);
      return;
    }

    this.caConfig = new Common.GridConfiguration([],0,'col');
    this.caConfig.setGridItems(
      new Common.GridItemConfiguration('諸掛取引先', 150),
      new Common.GridItemConfiguration('勘定科目', 150),
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('税区分', 150),
      new Common.GridItemConfiguration('支払予定日', 150),      
    );

    // プロパティの初期化
    this.caPic = this.$api.auth.userId;
    this.caBookDate = new Date().getCalendarDate();
    this.caCurrencyCode = (this.$api.tenantSettings as Common.TenantSettings).currencyCode;
    this.caExchangeRate = 1;
    this.caWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_charge');
    this.onChargeAllocationChangeWorkflow();

    // ダイアログの表示
    // var items = this.checkedDeliveryItems.map(item => item.copy());
    this.caItems = new Array();
    this.caItems.push(new Common.PurchaseCharge());
    (this.$refs.chargeAllocationDialog as Components.ListDialog).items = this.caItems;
    (this.$refs.chargeAllocationDialog as Components.ListDialog).showDialog();
  }
  public onChargeAllocationChangeWorkflow(){
    this.caButtonNames=new Array();
    this.caButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.caButtonNames.push("諸掛保存");
    if(this.caWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('charge', this.caWorkflowId, Common.ChargeStatus.ChargeSaving);
      actions.forEach(action => {
        this.caButtonNames.push(action.actionName);
        this.caButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // 取引先変更時に取引先の税区分・支払予定日を設定する
  public onChangeCounterpart(item: Common.Charge){
    item.taxCode = item.counterpart ? item.counterpart.taxCode : '';
    if(item.counterpart == null) item.dueDate = null;
    else  
    {
      var closingDate = item.counterpart.getClosingDate(this.caBookDate, this.tenantSettings);
      item.dueDate = item.counterpart.getPaymentDate(closingDate, this.tenantSettings);   
    } 
  }

  // 発生日変更時に支払予定日を設定する
  public onChangeChargeDate(){
    this.caItems.forEach(item =>{
      if(item.counterpart == null) item.dueDate = null;
      else  item.dueDate = item.counterpart.getPaymentDate(this.caBookDate, this.tenantSettings);
    });
    this.onChangeCurrency();
  }

  // 発生日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.caCurrencyCode;
    query.startDate = this.caBookDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.caExchangeRate = exchangeRate ? exchangeRate.rate : 1;
    });

    const obj = this.$api.currencies.filter(obj => obj.value == this.caCurrencyCode); 
    if (obj.length == 0) this.caDecimal = 0;
    else this.caDecimal = Number(obj[0].text);
  }

   public async submitChargeAllocation(list: Array<Common.PurchaseCharge>, index:number){
    // 選択している入荷伝票の取得    
    if (this.caItems.length == 0){
        this.$api.closeWaitCursor();
        return this.$api.modal.showDialog('無効な操作','諸掛を入力してください。').then(()=>{return false;});
    }    
    
    //ヘッダプロパティの設定
    this.caItems.forEach(charge =>{
      charge.currencyCode = this.caCurrencyCode;
      charge.exchangeRate = this.caExchangeRate;
      charge.proportionalDivision = this.caProportionalDivision;
      charge.workflowId = this.caWorkflowId;
      charge.chargeDate = this.caBookDate;
      charge.pic = this.caPic;
      charge.refNo = this.caRefNo;      
      charge.chargeFlag = Common.SalesPurchaseFlags.Purchase; //仕入諸掛
      charge.segment = this.checkedDeliveryItems[0].segment;
      charge.target = Common.ChargeItemTypes.Purchase;      
    });

    // クエリの設定
    var query = new Common.AddChargeAllocationQuery();
    query.charges = this.caItems; //諸掛のセット
    query.deliveryItems = this.checkedDeliveryItems; //按分対象のセット
    query.actionId = this.caButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    
    // 諸掛按分明細追加の実行
    return this.$api.execute(query,true).then(res => {
      //ダイアログ表示
      var charges = res as Common.PurchaseCharge[];
      var links = charges.map(charge=>new Common.ModalLink(charge.chargeNo,String.format('/purchase/PurchaseCharge?chargeNo={0}',charge.chargeNo)));
      //this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',true,null,links);
      this.$api.modal.show('処理結果','以下の諸掛伝票が作成されました。',false,()=>this.$router.push(String.format('/purchase/PurchaseCharge?chargeNo={0}',charges[0].chargeNo)),links,'伝票に移動する','閉じる');
      return true;
    }).catch(()=>{return false;});           
   }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType != Common.UsedTypes.None ;
  }       
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }  
}
